import type { ColumnsType } from "@similarweb/pro-logic-components";

import { columnNamesAndTooltipsMap, TABLE_COLUMN_DOMAIN } from "app/common/keyword-research/serp-players/consts";
import { CoreWebsiteCell } from "pro-features/components/core cells/src/CoreWebsiteCell/CoreWebsiteCell";
import { DefaultCellRightAlign, UrlCellWebsiteAnalysis } from "app/components/React/Table/cells";
import { translate } from "app/filters/i18nFilter";

import type { IActivationSetCellEnrichedTransformed } from "./types";

export const getColumns = (domainCount: number) =>
    [
        {
            dataIndex: "domain",
            title: `${translate(columnNamesAndTooltipsMap[TABLE_COLUMN_DOMAIN].title)} (${domainCount})`,
            tooltipSubtitle: translate(
                "keywordresearch.monitorkeywords.table.column.activation_set_leader.expanded_row.domain.tooltip",
            ),
            width: 88,
            align: "left",
            render: (rowCellData: { domain: string; favicon: string; internalLink: string }) => {
                return (
                    <CoreWebsiteCell
                        domain={rowCellData.domain}
                        icon={rowCellData.favicon}
                        internalLink={rowCellData.internalLink}
                    />
                );
            },
        },
        {
            dataIndex: "clicks",
            title: translate("keywordresearch.monitorkeywords.table.column.activation_set_leader.expanded_row.clicks"),
            tooltipSubtitle: translate(
                "keywordresearch.monitorkeywords.table.column.activation_set_leader.expanded_row.clicks.tooltip",
            ),
            width: 88,
            align: "right",
            render: (rowCellData) => <DefaultCellRightAlign value={rowCellData} />,
            sorter: true,
        },
        {
            dataIndex: "share",
            title: translate("keywordresearch.monitorkeywords.table.column.activation_set_leader.expanded_row.share"),
            tooltipSubtitle: translate(
                "keywordresearch.monitorkeywords.table.column.activation_set_leader.expanded_row.share.tooltip",
            ),
            width: 88,
            align: "right",
            render: (rowCellData) => <DefaultCellRightAlign value={rowCellData} />,
            sorter: true,
        },
        {
            dataIndex: "topUrl",
            title: translate("keywordresearch.monitorkeywords.table.column.activation_set_leader.expanded_row.top_url"),
            tooltipSubtitle: translate(
                "keywordresearch.monitorkeywords.table.column.activation_set_leader.expanded_row.top_url.tooltip",
            ),
            render: (rowCellData: string) => <UrlCellWebsiteAnalysis value={rowCellData} />,
            width: 232,
            align: "left",
        },
    ] as ColumnsType<IActivationSetCellEnrichedTransformed["data"][number]>;
